import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../auth/api";
import { alertSuccess, alertError } from "../components/Alert";

// Fetch Help Support Help
export const fetchHelpSupportHelp = createAsyncThunk(
  "helpSupportHelp/fetchHelpSupportHelp",
  async (params = {}, { rejectWithValue }) => {
    try {
      const { page = 1, page_size = 10, in_progress = "", is_resolve = "", search = "" } = params;
      let url = `/HelpSupport/panel/Help?page=${page}&page_size=${page_size}`;
      if (in_progress !== "") {
        url += `&in_progress=${in_progress}`;
      }
      if (is_resolve !== "") {
        url += `&is_resolve=${is_resolve}`;
      }
      if (search) {
        url += `&search=${encodeURIComponent(search)}`;
      }
      const response = await api.get(url);
      return {
        data: response.data,
        page,
        pageSize: page_size,
        in_progress,
        is_resolve,
        search
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Add Help Support Help
export const addHelpSupportHelp = createAsyncThunk(
  "helpSupportHelp/addHelpSupportHelp",
  async (newHelpData, { rejectWithValue }) => {
    try {
      const response = await api.post("/HelpSupport/panel/Help", newHelpData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  } 
);

// Update Help Support Help
export const updateHelpSupportHelp = createAsyncThunk(
  "helpSupportHelp/updateHelpSupportHelp",
  async (helpData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/HelpSupport/panel/Help", helpData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Help Support Help Slice
const helpSupportHelpSlice = createSlice({
  name: "helpSupportHelp",
  initialState: {
    helpSupportHelpList: { result: [], pagination: {} },
    currentPage: 1,
    pageSize: 10,
    totalPages: 1,
    inProgressFilter: "",
    isResolveFilter: "",
    search: "",
    status: "idle", // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
      state.currentPage = 1;
    },
    setFilters: (state, action) => {
      const { inProgressFilter, isResolveFilter, search } = action.payload;
      if (inProgressFilter !== undefined) state.inProgressFilter = inProgressFilter;
      if (isResolveFilter !== undefined) state.isResolveFilter = isResolveFilter;
      if (search !== undefined) state.search = search;
      state.currentPage = 1;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch Help Support Help
      .addCase(fetchHelpSupportHelp.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchHelpSupportHelp.fulfilled, (state, action) => {
        state.status = "succeeded";
        const { data, page, pageSize, in_progress, is_resolve, search } = action.payload;
        state.helpSupportHelpList = data;
        state.currentPage = page;
        state.pageSize = pageSize;
        state.inProgressFilter = in_progress;
        state.isResolveFilter = is_resolve;
        state.search = search;
        
        const count = data?.pagination?.count || data?.pagination?.total_count || 0;
        state.totalPages = data?.pagination?.total_pages || Math.ceil(count / pageSize) || 1;
      })
      .addCase(fetchHelpSupportHelp.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Add Help Support Help
      .addCase(addHelpSupportHelp.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addHelpSupportHelp.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addHelpSupportHelp.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Update Help Support Help
      .addCase(updateHelpSupportHelp.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateHelpSupportHelp.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateHelpSupportHelp.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearError, setPage, setPageSize, setFilters } = helpSupportHelpSlice.actions;

export default helpSupportHelpSlice.reducer;
